import { useState } from "react";
import { useNavigate } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IoIosArrowBack } from "react-icons/io";
import Header from "../Header.js";


const ProfileSetting = ({ backLink = "/dashboard", details = [], showHeader = true, showBackLink = true, className = "" }) => {
    const navigate = useNavigate();
    
    return (
        <>
            <div className={`profile-wrapper ${className}`}>
                {showHeader && <Header />}
                {/* dashboardに戻る */}
                {showBackLink && (
                    <div onClick={() => navigate(backLink)} style={{ cursor: "pointer" }} className="nav_title">
                        <IoIosArrowBack />
                        Your Profile
                    </div>
                )}
                <div className="prof-setting-content">
                    {details.map((item, i) => (
                        <p key={i}>{item}</p>
                    ))}
                    <p>Contact your manager if additional information is needed to proceed with changes</p>
                </div>
            </div>
        </>
    );

}

export default ProfileSetting;